import { css } from "styled-components";

export default css`
  font-weight: bold;
  font-size: 25px;
  text-transform: uppercase;
`;
